 const isLocalHostname = (hostname: string): boolean => {
    const normalized = hostname.trim().toLowerCase();
    return normalized === "localhost" || normalized === "127.0.0.1" || normalized === "::1";
  };

  export const resolveApiBase = (envValue: string | undefined, prodDefault: string, devDefault: string): string => {
    const raw = (envValue || "").trim();
    if (typeof window !== "undefined" && !isLocalHostname(window.location.hostname || "")) {
      // Sempre relativo em dominio real (garante nunca usar localhost no browser)
      return prodDefault;
    }
    if (raw) return raw;
    return devDefault;
  };